import { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useQuotationHistory } from '@/services'
import { Accordion, Text } from '@mercai/clever'

import { groupHistoryByDay } from './history.constants'

import { HistoryTimeline } from '@/components'
import { formatLongDate } from '@/helpers'
import { useTranslation } from 'react-i18next'
import styles from './history.module.css'

export const History = () => {
  const { t } = useTranslation('screenQuotationV2Show')

  const { uuid } = useParams()

  const { data, isLoading } = useQuotationHistory(uuid)

  const [activeItems, setActiveItems] = useState<string[]>([])

  const formattedData = useMemo(
    () => groupHistoryByDay(data?.data?.timeline),
    [data?.data?.timeline],
  )

  useEffect(() => {
    setActiveItems(formattedData?.map((_, i) => `history-${i}`) || [])
  }, [formattedData])

  return (
    <div className={styles.container}>
      <Text variant="title-medium">
        {t('quotationTabHistoryTitle', {
          value: data?.data?.timeline?.length || 0,
        })}
      </Text>
      {!isLoading &&
      data?.data?.timeline &&
      data?.data?.timeline?.length > 0 ? (
        <div>
          <Accordion.Root
            activeItems={activeItems}
            onHandleActiveItems={setActiveItems}
          >
            {formattedData.map((items, index) => (
              <Accordion.Item
                key={index}
                id={`history-${index}`}
                header={
                  <Text className={styles.header} variant="text-small">
                    {formatLongDate(items?.[0]?.createdAt)}
                  </Text>
                }
                className={styles.item}
              >
                <div className={styles.content}>
                  <HistoryTimeline
                    items={items}
                    translationKey="quotationHistoryEnums"
                    coreEntity="quotation"
                  />
                </div>
              </Accordion.Item>
            ))}
          </Accordion.Root>
        </div>
      ) : (
        <Text variant="text-base">{t('quotationTabHistoryEmpty')}</Text>
      )}
    </div>
  )
}
